import { Component, OnInit, Input, forwardRef, NgModule, TemplateRef, Output, EventEmitter, ViewChild, ViewContainerRef, ElementRef, ContentChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule, NgForOfContext } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { API } from '../services/api';
import { Subject } from 'rxjs/Rx';

export interface Master {
    preview: string;
    realName?: string;
    mobile?: string;
    id?: string;
    disabled?: boolean;
}

export interface DomOpt {
    hasBankCard: boolean;
    mobile: string;
    realName: string;
}

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MasterSelectComponent),
    multi: true
};
export class MasterSelectComponent implements ControlValueAccessor, OnInit {

     domOpt: DomOpt;
private onTouchedCallback: () => () => {};
private onChangeCallback: (_: any) => () => {};

    options: Array<Master> = [];
    // 单选的时候传字符串，多选传数组
    _value: string;
    _width = "100%";
    _content: TemplateRef<any>;
    _allowClear = true;
    _nzMode = "combobox";
    // 下拉过滤含关键字选项，false为不过滤
    _filter = false;
    currentText = '';
    canQuery = true;
    keyWordStream = new Subject<string>()
    keyWord$: any;
    regExpNum: RegExp = /^[0-9]*$/;

     placeholder = "请输入收货人";
    // 需要获取的值类型
     valueType = "object";
    // 显示在输入框的值（名字、电话、名字+电话）
     valueField = "realName";
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        if (typeof v === 'string' && v.trim() === '' || !v)
            this.queryData('', []);
        this._value = v;
        // 双向绑定获取对象
        if (this.valueType === "object") {
            this.onChangeCallback(v);
        } else {
            let /** @type {?} */ realName = v.realName || v;
            let /** @type {?} */ mobile = v.mobile || v;
            this.valueType === "mobile" ? this.onChangeCallback(mobile) : this.onChangeCallback(realName);
        }
    }
/**
 * @return {?}
 */
get value(): any {
        return this._value;
    };
/**
 * @param {?} v
 * @return {?}
 */
set width(v: any) {
        const /** @type {?} */ width = parseInt(v);
        this._width = ( /** @type {?} */((<any>Array.from(v)))).includes("%") ? `${v}%` : isNaN(width) ? this._width : `${width}px`;
    }
/**
 * @param {?} v
 * @return {?}
 */
set OptionMode(v) {
        this._nzMode = v;
        this._allowClear = v === "combobox" ? true : false;
    };
/**
 * @param {?} tpl
 * @return {?}
 */
set customTemplate(tpl: TemplateRef<any>) {
        if (tpl instanceof TemplateRef) {
            this._content = tpl;
        }
    }

     openChange: EventEmitter<any> = new EventEmitter();
     outOptions: EventEmitter<any> = new EventEmitter();
/**
 * @param {?} api
 */
constructor(private api: API) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        // 限流
        this.keyWord$ = this.keyWordStream
            .debounceTime(250)
            .subscribe(word => {
                this.queryData(word, [])
            });

    }
/**
 * @return {?}
 */
ngOnDestroy() {
        this.keyWord$.unsubscribe()
    }
/**
 * @param {?} event
 * @return {?}
 */
yztSearchChange(event) {
        this.canQuery = true;
        this.currentText = event;
        this.keyWordStream.next(event);
    }
/**
 * 仅作清空多选选项
 * @param {?=} $event
 * @return {?}
 */
clearSelect($event?: MouseEvent): void {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this.options = [];
        this.value = '';
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this._value) {
            this._value = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * 查询数据
 * @param {?=} searchText
 * @param {?=} options
 * @return {?}
 */
queryData(searchText?: string, options?: Array<Master>) {
        if (!this.canQuery) return;

        let /** @type {?} */ qryParams = {
            realName: "",
            mobile: ""
        }
        if (this.regExpNum.test(searchText)) {
            qryParams.mobile = searchText;
        } else {
            qryParams.realName = searchText;
        }

        this.api.call("UserWorkerController.findMasterByNameOrAccount", qryParams).ok(json => {
            const /** @type {?} */ result = json.result || [];
            this.options = result;
            this.options.forEach(item => {
                item.preview = item[this.valueField];
            });
            this.outOptions.emit(this.options);
        }).fail(err => {
            if (!this.options.length) {
                const /** @type {?} */ lastItem = new Array<Master>({ id: "empty", preview: "没有更多选项！", disabled: true });
                this.options = options.concat(lastItem);
                this.canQuery = false;
                return;
            }
            throw new Error(err);
        });
    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: `yzt-master`,
    template: `
    <div class="master-select">
        <nz-select 
            class="master-nz-select"
            [style.width]="_width" 
            [nzPlaceHolder]="placeholder" 
            [nzMode]="_nzMode"
            [nzFilter]="_filter"
            [nzAllowClear]="_allowClear"
            (nzSearchChange)="yztSearchChange($event)"
            [(ngModel)]="value">
            <nz-option
                #domOpt
                *ngFor="let option of options"
                [nzLabel]="option.preview"
                [nzValue]="option"
                [nzDisabled]="option.disabled">
                <ng-template *ngIf="_content" #nzOptionTemplate>
                    <ng-container #nzOptionCon [ngTemplateOutlet]="_content" [ngTemplateOutletContext]="option"></ng-container>
                </ng-template>
            </nz-option>
        </nz-select>
        <span
        role="close-icon"
        (click)="clearSelect($event)"
        class="ant-select-selection__clear close-icon"
        style="-webkit-user-select: none;"
        *ngIf="!_allowClear&&options.length">
        </span>
    </div>
    `,
    styles: [`
    .master-select{
        position: relative;
    }
    .close-icon {
        opacity: 0;
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -10px;
    }
    .close-icon:hover {
        opacity: 1;
    }
    .master-nz-select:hover +.close-icon {
        opacity: 1;
    }
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: API, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'domOpt': [{ type: ViewChild, args: ["domOpt", ] },],
'placeholder': [{ type: Input },],
'valueType': [{ type: Input },],
'valueField': [{ type: Input },],
'width': [{ type: Input },],
'OptionMode': [{ type: Input },],
'customTemplate': [{ type: Input },],
'openChange': [{ type: Output },],
'outOptions': [{ type: Output },],
};
}

function MasterSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
MasterSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MasterSelectComponent.ctorParameters;
/** @type {?} */
MasterSelectComponent.propDecorators;
/** @type {?} */
MasterSelectComponent.prototype.domOpt;
/** @type {?} */
MasterSelectComponent.prototype.onTouchedCallback;
/** @type {?} */
MasterSelectComponent.prototype.onChangeCallback;
/** @type {?} */
MasterSelectComponent.prototype.options;
/** @type {?} */
MasterSelectComponent.prototype._value;
/** @type {?} */
MasterSelectComponent.prototype._width;
/** @type {?} */
MasterSelectComponent.prototype._content;
/** @type {?} */
MasterSelectComponent.prototype._allowClear;
/** @type {?} */
MasterSelectComponent.prototype._nzMode;
/** @type {?} */
MasterSelectComponent.prototype._filter;
/** @type {?} */
MasterSelectComponent.prototype.currentText;
/** @type {?} */
MasterSelectComponent.prototype.canQuery;
/** @type {?} */
MasterSelectComponent.prototype.keyWordStream;
/** @type {?} */
MasterSelectComponent.prototype.keyWord$;
/** @type {?} */
MasterSelectComponent.prototype.regExpNum;
/** @type {?} */
MasterSelectComponent.prototype.placeholder;
/** @type {?} */
MasterSelectComponent.prototype.valueType;
/** @type {?} */
MasterSelectComponent.prototype.valueField;
/** @type {?} */
MasterSelectComponent.prototype.openChange;
/** @type {?} */
MasterSelectComponent.prototype.outOptions;
/** @type {?} */
MasterSelectComponent.prototype.api;
}

export class MasterSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule,
    ],
    declarations: [
        MasterSelectComponent
    ],
    exports: [MasterSelectComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MasterSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
MasterSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MasterSelectModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
